<div class="shop-category-filter row column" *ngIf="categories && categories.length > 0">
	<div class="button-group align-center" *ngIf="showCategoryDropDown === false">
		<a class="button" tabindex="0" role="radio" [attr.aria-label]="'shop.category.select' | translate" [class.active]="currentCategory === null" (click)="setCategory(null)" (keydown.space)="setCategory(null)">{{'shop.category.all' | translate}} ({{totalVisibleItems.length}})</a>
		<a class="button" tabindex="0" role="radio" [attr.aria-label]="'shop.category.select' | translate" [class.active]="currentCategory === category.id" (click)="setCategory(category.id)" (keydown.space)="setCategory(category.id)" *ngFor="let category of categories">{{category.name}} ({{category.product_count}})</a>
	</div>
	<select *ngIf="showCategoryDropDown === true" (change)="setCategory(categegorySelect.value)" #categegorySelect [attr.aria-label]="'shop.category.select' | translate">
		<option [selected]="currentCategory === null" value="">{{'shop.category.all' | translate}} ({{totalVisibleItems.length}})</option>
		<option [selected]="currentCategory === category.id" [value]="category.id" *ngFor="let category of categories">{{category.name}} ({{category.product_count}})</option>
	</select>
</div>

<div class="shop-product-list row column" *ngIf="items && items.length > 0">
	<div shop-list-item class="small-12 medium-6 large-4 xlarge-3" 
		[currency]="donation.currencySymbol" 
		[item]="item" 
		(onShowItem)="showItem($event)"
		(onShowDownloadForProduct)="showDownloadForProduct($event)" 
		(addItem)="addItemToChart($event)" 
		(availableCountChanged)="calculateVisibleItems()"
		*ngFor="let item of currentlyVisibleItems | slice:0:page * itemsPerPage" 
		[attr.data-product-id]="item.id">
	</div>
</div>
<div class="shop-product-list-empty row column text-center" *ngIf="items && items.length === 0" [innerHTML]="'shop.list.noproducts' | translate"></div>

<div class="shop-list-more row column" *ngIf="items && (items.length > page * itemsPerPage)">
	<a (click)="showNextPage()" (keydown.enter)="showNextPage()" (keydown.space)="showNextPage()" tabindex="0" role="button" [innerHTML]="'shop.list.more' | translate"></a>
</div>

<div class="shop-product-list-buttons row column" *ngIf="items && items.length > 0" [class.is-sticky]="buttonPlaceholder.items > 0 && !isEmbedded()">
	<div class="sticky-wrapper">
		<p [innerHTML]="(buttonPlaceholder.items === 1? 'shop.list.button.teaser.single' :'shop.list.button.teaser') | translate: buttonPlaceholder"></p>
		<button class="button arrow arrow-right" [class.grey]="buttonPlaceholder.items <= 0" (click)="changeStep('cart')" [innerHTML]="'shop.list.button' |  translate: buttonPlaceholder "></button>
	</div>
</div>
